<template>
    <div class="drag-list">
        <slot></slot>
    </div>
</template>

<script>
  import {ContainerMixin} from './vue-slicksort';

  export default {
    name: "DragList",
    mixins: [ContainerMixin]
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/c_drag/DragList.vue